/**
 * Format a date string to English format: "day month(full) year"
 * Example: "9 April 2026"
 * 
 * @param {string|Date|null|undefined} dateValue - ISO date string, Date object, or null/undefined
 * @returns {string} Formatted date string or fallback value
 */
export const formatEnglishDate = (dateValue) => {
  if (!dateValue) return "N/A";
  
  try {
    const date = new Date(dateValue);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "N/A";
    }
    
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  } catch (error) {
    console.error('Error formatting date:', error);
    return "N/A";
  }
};

/**
 * Format a date range to English format
 * Example: "9 April 2026 to 9 April 2027"
 * 
 * @param {string|Date|null|undefined} startDate - Start date
 * @param {string|Date|null|undefined} endDate - End date
 * @returns {string} Formatted date range string
 */
export const formatEnglishDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return "N/A";
  
  const start = formatEnglishDate(startDate);
  const end = formatEnglishDate(endDate);
  
  if (start === "N/A" || end === "N/A") return "N/A";
  
  return `${start} to ${end}`;
};
